import { themeTokens } from "shared/theme/sidespor/theme/themeSemantics";
import { defineDataSemantics } from "shared/theme/sidespor/define/dataSemantics";
import { defineSlotRecipe } from "shared/theme/sidespor/define/slotRecipe";
import { SystemStyleObject } from "shared/theme/sidespor/types";

export const tableRecipe = defineSlotRecipe({
  base: {
    row: defineDataSemantics((theme) => ({
      backgroundColor: theme.colorSemanticFill,
    })),
  } as SystemStyleObject,
  variants: {
    variant: {
      sidespor: {
        root: {
          "&&&": { borderRadius: "6px", backgroundColor: "transparent" },
          // We need to use outline instead of border since borders don't work properly for table roots
          outlineWidth: "1px",
          outlineStyle: "solid",
          outlineColor: themeTokens.colorOutlineDisabled,
          outlineOffset: "-1px",
        },
        columnHeader: {
          "&&&": { fontSize: "mobile.sm" },
          backgroundColor: "var(--spor-colors-bg-tertiary)",
          _first: { borderTopLeftRadius: "6px" },
          _last: { borderTopRightRadius: "6px" },
          padding: "9px 18px",
        },
        row: {
          // We need to use boxShadow instead of border in order to position it inside the table
          borderBottom: `sm`,
          borderColor: themeTokens.colorOutlineDisabled,
          // You can't put borderRadius on rows, so we need to target the cells
          _last: {
            borderBottom: "none",
            "& td:first-of-type": { borderBottomLeftRadius: "6px" },
            "& td:last-of-type": { borderBottomRightRadius: "6px" },
          },
        },
        cell: {
          backgroundColor: "inherit", // Having both the row and cell be the row color helps prevent subpixel gaps
          "&&&": { fontSize: "mobile.sm" },
          padding: "9px 18px",
        },
      } as SystemStyleObject,
      card: {
        root: {
          "&&&": { backgroundColor: "transparent" },
          borderSpacing: "0px 6px",
          borderCollapse: "separate",
        },
        header: {
          "&&&": { backgroundColor: "transparent" },
          "& tr": { backgroundColor: "transparent" },
        },
        columnHeader: {
          backgroundColor: "transparent",
          "&:first-of-type": { borderLeftRadius: "6px" },
          "&:last-of-type": { borderRightRadius: "6px" },
          padding: "6px 18px",
        },
        row: {
          backgroundColor: "var(--spor-colors-bg-tertiary)",
        },
        cell: {
          "&&&": { fontSize: "mobile.sm" },
          backgroundColor: "inherit", // Having both the row and cell be the row color helps prevent subpixel gaps
          "&:first-of-type": { borderLeftRadius: "6px" },
          "&:last-of-type": { borderRightRadius: "6px" },
          padding: "9px 18px",
        },
      } as SystemStyleObject,
    },
  },
});
